import Layout from '@/layout'

const route = {
  path: '/anonymousLetter',
  component: Layout,
  redirect: '/anonymousLetter/index',
  alwaysShow: true, // will always show the root menu
  name: 'anonymousLetter',
  meta: {
    title: '飞书管理',
    icon: 'diy-FzUuGrLi',
    roles: [
      'feishu'
    ]
  },
  children: [
    {
      path: '/businessmanagement/index',
      component: () => import('@/views/businessmanagement/index.vue'),
      name: 'Businessmanagement',
      meta: {
        title: '应用管理',
        // icon: 'component',
        roles: [
          'feishu.app.index'
        ]
      }
    },
    // {
    //   path: '/depamanagement/index',
    //   component: () => import('@/views/depamanagement/index.vue'),
    //   name: 'sourceMaterial',
    //   meta: {
    //     title: '部门管理',
    //     icon: 'component',
    //     roles: [
    //       'message.templateList'
    //     ]
    //   }
    // },
    // {
    //   path: '/empmanagement/index',
    //   component: () => import('@/views/empmanagement/index.vue'),
    //   name: 'sourceMaterial',
    //   meta: {
    //     title: '员工管理',
    //     icon: 'component',
    //     roles: [
    //       'message.templateList'
    //     ]
    //   }
    // },
    {
      path: '/groupmanagement/index',
      component: () => import('@/views/groupmanagement/index.vue'),
      name: 'Groupmanagement',
      meta: {
        title: '群聊管理',
        // icon: 'component',
        roles: [
          'feishu.chat'
        ]
      }
    },
    {
      path: '/anonymousletter/index',
      component: () => import('@/views/anonymousletter/index.vue'),
      name: 'Anonymousletter',
      meta: {
        title: '飞书错误配置',
        // icon: 'component',
        roles: [
          'feishu.chat.errorAlarmList'
        ]
      }
    }

  ]
}

export default route
